import React, { useRef, useState, useEffect } from 'react';
import { handleBooleanProp } from 'utils/commonUtils';
import { OutlinedButton, LightTooltip, TruncatedText } from 'components/Ui/styled';

const OutlinedButtonComponent = (props) => {
  const { handleClick, selectedItem, item, id, primary, isSubject, available } = props;
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowed(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [item]);

  const buttonContent = (
    <OutlinedButton
      variant="outlined"
      disabled={available === false}
      onClick={() => handleClick(item)}
      available={handleBooleanProp(available)}
      aria-pressed={selectedItem === id ? 'true' : 'false'}
      primary={handleBooleanProp(primary)}
      subjectbutton={isSubject ? 'true' : undefined}
    >
      <TruncatedText ref={textRef}>
        {item}
      </TruncatedText>
    </OutlinedButton>
  );

  return (
    <LightTooltip
      title={isOverflowed ? item : ''}
      placement="top"
      disableHoverListener={!isOverflowed}
    >
      {buttonContent}
    </LightTooltip>
  );
};

export default OutlinedButtonComponent;
